import { cipo } from 'cipo';

cipo.controller('pspdfkitAttachmentViewerController',
    function ($scope, $mdDialog, MODAL, attachment, list, userService, PSPDFKitInstance, URI, Message) {
    /* VARIABLES */
        $scope.list = list;
        let attachmentIndex = list.map(function (e) { return e.id }).indexOf(attachment) || 0;
        $scope.modalInfo = MODAL;
        $scope.isLoading = false;
        $scope.isBusy = false;
        $scope.title = list[attachmentIndex].name;
        $scope.loadDocument = _loadDocument;
        $scope.close = _close;
        $scope.showClickMessage = false;
        /* END VARIABLES */

        /* INIT */
        // $scope.setTitle($scope.isViewOnly);
        $scope.pspdfkitInstance = new PSPDFKitInstance({
            moduleId: null,
            entityInstanceId: 0,
            currentUserId: userService.system.userdata.id,
            isLoading: function (isLoading) { 
                if (isLoading) {
                    $('.loaderOverlayWrapperGlobal').show();
                }
                else {
                    $('.loaderOverlayWrapperGlobal').hide();
                }
            },
            placeIconCallback: function (isVisible) { 
                $scope.showClickMessage = isVisible; 
                $scope.$apply();
            }
        });


        $scope.loadDocument();
        /* END INIT */

        $scope.next = function () {
            list[attachmentIndex].isActive = false;
            attachmentIndex = attachmentIndex < $scope.list.length - 1 ? attachmentIndex + 1 : 0;
            // updateActive(attachmentIndex);
            $scope.pspdfkitInstance.unload(true);
            $scope.loadDocument();
        }

        $scope.previous = function () {
            list[attachmentIndex].isActive = false;
            attachmentIndex = attachmentIndex > 0 ? attachmentIndex - 1 : $scope.list.length - 1;
            // updateActive(attachmentIndex);
            $scope.pspdfkitInstance.unload(true);
            $scope.loadDocument();
        }

        $scope.select = function (o) {
            list[attachmentIndex].isActive = false;
            attachmentIndex = $scope.list.map(function (e) { return e.id }).indexOf(o.id) || 0;
            // updateActive(attachmentIndex);
            $scope.pspdfkitInstance.unload(true);
            $scope.loadDocument();
        }

        /* WATCHERS */
        $scope.$watch(function () {
            return document.querySelector('#pspdfkit').innerHTML;
        },
            function (n, o) {
                if (n != o) {
                    n.length > 0 ? $('#pspdfkitLoadingMsg').hide() : $('#pspdfkitLoadingMsg').show();
                }
            });
        /* END WATCHERS */

        // Sets the title of the dialog
        function _setTitle(isViewOnly) {
            if (!isViewOnly)
                $scope.title = `${$scope.module.name} - ${$scope.title}`;
        }

        // Loads the document provided to the viewer
        function _loadDocument() {
            list[attachmentIndex].isActive = true;
            $scope.title = list[attachmentIndex].name;
            $scope.pspdfkitInstance[URI.MY_CIPO_DRIVE.GET_FILE_URL.method](`${URI.MY_CIPO_DRIVE.GET_FILE_URL}?versionId=${list[attachmentIndex].versionId}&isPreview=false`)
                .then(function (response) {
                    $scope.pspdfkitInstance.view(response?.url, list[attachmentIndex].id, list[attachmentIndex].mimeType)
                })
                .catch(function (e) {
                    Message.dberror(e);
                });
            
        }

        // Unloads the document instance and then closes dialog.
        function _close(isViewOnly) {
            $scope.pspdfkitInstance.unload(isViewOnly);
            $mdDialog.cancel();
        }
    });
